import React from 'react'
import { Eye } from 'lucide-react'
import type { ReferralTrackingProps } from '@/features/enrollment'

export default function ReferralTracking({ 
  showReferralTracking, 
  referralTracking, 
  trackReferralProgress 
}: ReferralTrackingProps) {
  return (
    <div className="border border-blue-200 rounded-lg p-4 lg:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4 gap-4">
        <div>
          <h4 className="font-semibold text-blue-900">Referral Tracking</h4>
          <p className="text-sm text-blue-600">Track your referrals' progress through the enrollment process</p>
        </div>
        <button
          onClick={trackReferralProgress}
          className="btn-primary flex items-center space-x-2"
        >
          <Eye className="w-4 h-4" />
          <span>Track Referrals</span>
        </button>
      </div>
      
      {showReferralTracking && (
        <div className="bg-blue-50 border border-blue-200 rounded p-4 space-y-3">
          <h5 className="font-medium text-blue-900 mb-3">Referral Progress</h5>
          {referralTracking.length > 0 ? (
            <div className="space-y-2">
              {referralTracking.map((referral, index) => (
                <div key={index} className="bg-white border border-blue-200 rounded p-3">
                  <div className="flex items-center justify-between">
                    <span className="font-medium text-blue-900">{referral.email}</span>
                    <span className={`px-2 py-1 rounded text-xs font-medium ${
                      referral.status === 'completed' 
                        ? 'bg-green-100 text-green-700' 
                        : 'bg-yellow-100 text-yellow-700'
                    }`}>
                      {referral.status === 'completed' ? 'Completed' : `Step ${referral.step}`}
                    </span>
                  </div>
                  <p className="text-xs text-blue-600 mt-1">
                    Last activity: {new Date(referral.lastActivity).toLocaleDateString()}
                  </p>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-blue-600 text-sm">No referrals to track yet. Add referrals above to see their progress.</p>
          )}
        </div>
      )}
    </div>
  )
}
